import axiosInstance from './AxiosInstance';

const API_URL = 'file';

// Function to handle file uploads with progress
export const uploads = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append('files', file); // Append the single file to FormData

  try {
    const response = await axiosInstance.post(`${API_URL}/uploads`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Ensure the content type is set correctly
      },
      onUploadProgress: (progressEvent) => {
        // Call the progress callback with the current upload progress
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onUploadProgress(percentCompleted);
        }
      },
      timeout: 600000,
    });
    return response.data; // Return the response data after successful upload
  } catch (error) {
    console.error('Error while uploading file', error);
    throw error; // Re-throw the error for further handling
  }
};

export const deleteFile = async (name) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/delete`, { fileName: name });
    return response.data;
  } catch (error) {
    console.error(`Error while deleting file with name ${name}`, error);
    throw error;
  }
};

export const deleteAEAFile = async (name) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/aea-delete`, { fileName: name });
    return response.data;
  } catch (error) {
    console.error(`Error while deleting file with name ${name}`, error);
    throw error;
  }
};

export const deleteSHSFile = async (name) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/shs-delete`, { fileName: name });
    return response.data;
  } catch (error) {
    console.error(`Error while deleting file with name ${name}`, error);
    throw error;
  }
};

export const deleteTrainingFile = async (name) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/training-delete`, { fileName: name });
    return response.data;
  } catch (error) {
    console.error(`Error while deleting file with name ${name}`, error);
    throw error;
  }
};
